import { Pipe, PipeTransform } from '@angular/core'

import { Participant } from '@core/data'
import { participantAvatar } from '@shared/utils/participant-avatar'

@Pipe({
  name: 'participantAvatar'
})
export class ParticipantAvatarPipe implements PipeTransform {
  transform(participant: Participant): string {
    return participantAvatar(participant)
  }
}
